import React, { createContext, useContext, useState } from 'react';
import { mockProducts as defaultMockProducts } from '../components/mockProducts';

export const ProductContext = createContext();

export const useProductContext = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
  const [mockProducts, setMockProducts] = useState(defaultMockProducts);

  const addProduct = async (product) => {
    try {
      // TODO: Replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      setMockProducts(prevProducts => [...prevProducts, product]);
      return 'Product added successfully';
    } catch (error) {
      throw error;
    }
  };

  return (
    <ProductContext.Provider value={{ mockProducts, addProduct }}>
      {children}
    </ProductContext.Provider>
  );
};
